import {useState, useEffect, useContext} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import { Tabs, Tab, Button } from 'react-bootstrap';
import Users from './users';
import CategoryTags from './CategoryTags';
import SchoolAuthenticationcode from './AuthCode';
import Parents from './ParentsDetails';
import AddOrganistaion from './AddOrganistaion';
import InternalUsers from './internalusers';
import MyAccount from './MyAccount';
import HelpText from './HelpText';
import Plans from './plans';
import Organisation from './organisation';
import ModifyDetails from '../ModifySchoolDetails/ModifyDetails';
import style from './OrgSetting.module.css';
import fontSize from '../Style/FontSize.module.css';
import common from '../Style/common.module.css';
import button from '../Style/ButtonStyle.module.css';
import font from '../Style/FontFamily.module.css';
import '../Style/Table-style.css';
import { getOrganisationDetails } from '../../services/Organisation';
import AuthContext from "../../store/auth-context";
import { USERS_API_BASE_URL } from '../../constants';
import { has } from 'immutable';

// Tab mapping configuration
const TAB_MAPPING = {
    users: 'zero',
    category: 'first',
    contactdetails: 'modify',
    parents: 'second',
    schoolauthenticationcode: 'Fourth',
    helpMessage: 'Fifth',
    plans: 'sixth',
    organisations: 'seventh',
    myAccount: 'eighth',
    internalUser: 'nineth'
};

const TAB_TO_HASH = {
    zero: 'users',
    first: 'category',
    modify: 'contactdetails',
    second: 'parents',
    Fourth: 'schoolauthenticationcode',
    Fifth: 'helpMessage',
    sixth: 'plans',
    seventh: 'organisations',
    eighth: 'myAccount',
    nineth: 'internalUser'
};

const OrgSetting = (props) => {
    const authCtx = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    
    const [isRecipientModalOpen, setIsRecipientModalOpen] = useState(false);
    const [OrganisationList, setOrganisationList] = useState([]);
    const [selectedCode, setSelectedCode] = useState('');
    const [key, setKey] = useState('first');
    const [isOrgCreated, setIsOrgCreated] = useState(true);
    const [isOrgConfigured, setIsOrgConfigured] = useState(true);
    const [hasCategoryTagsAdded, setHasCategoryTagsAdded] = useState(true);
    const [hasVarificationCodeGenerated, setHasVerificationCodeGenerated] = useState(true);
    const [hasParentsAdded, setHasParentsAdded] = useState(false);


    const recipientModalHendler = () => {
        setIsRecipientModalOpen((prevState) => !prevState);
    };

    // Handle URL hash changes
    useEffect(() => {
        const hash = location.hash.substring(1);
        const [hashPart, queryPart = ''] = hash.split('?');

        const tabKey = TAB_MAPPING[hashPart] || 'first';
        setKey(tabKey);
        setSelectedCode(queryPart);
    }, [location.hash]);

    // Fetch organizations
    useEffect(() => {
        if (!authCtx.token) return;
        getOrganisationDetails(authCtx.token)
            .then((res) => setOrganisationList(res.data))
            .catch(error => console.log(error));
    }, [authCtx.token]);
    
    // Check if organization is configured
    useEffect(() => {
        const orgUuid = authCtx.userData?.orgId;
        if (!orgUuid || !authCtx.token) return;
        
        fetch(`${USERS_API_BASE_URL}/organisation/${orgUuid}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": authCtx.token
            }
        })
        .then(res => res.json())
        .then(data => {
            if (!data.error) {
                const hasSendGrid = !!data.sendgrid_api_key;
                const hasWistia = !!data.org_wistia_project_id;
                setIsOrgConfigured(hasSendGrid && hasWistia);
            }
        })
        .catch(err => console.error('Error checking org configuration:', err));
    }, [authCtx.userData?.orgId, authCtx.token]);

    // Guard: Prevent rendering if userData is null (logout in progress)
    if (!authCtx.userData || !authCtx.isLoggedIn) {
        return null;
    }

    const orgUuid = authCtx.userData.orgId;

    // Helper functions for permission checks
    const isInternalUser = authCtx.userData.usertype === 'INTERNALADMIN' || authCtx.userData.usertype === 'OWNER';
    const isOwner = authCtx.userData.usertype === 'OWNER';
    const hasOrgPermission = authCtx.userData.usertype === 'INTERNALADMIN' && 
                            authCtx.userData.userPermission && 
                            JSON.stringify(authCtx.userData.userPermission).includes('2');
    // When OWNER/INTERNALADMIN has impersonated (has orgId), they should see tabs like a regular admin
    const isImpersonated = isInternalUser && orgUuid && orgUuid !== '';
    const showRegularAdminView = !isInternalUser || isImpersonated;

    const selectTab = (eventKey) => {
        const hash = TAB_TO_HASH[eventKey] || 'parents';
        navigate(`/Organisation#${hash}`);
        setKey(eventKey);
    };

    const completedStepColor='#45C096';
    const pendingStepColor='#d0d0d0';

    return (
        <div className="">
            {isRecipientModalOpen && (
                <AddOrganistaion
                    modalStatus={isRecipientModalOpen}
                    onAction={recipientModalHendler}
                />
            )}
            
            {!(isOrgConfigured && hasCategoryTagsAdded && hasVarificationCodeGenerated) && (
                <div style={{
                    padding: '30px 40px',
                    backgroundColor: '#f8f9fa',
                    borderBottom: '1px solid #e0e0e0'
                }}>
                    <h3 style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        marginBottom: '25px',
                        color: '#333'
                    }}>
                        Organisation Setup Progress
                    </h3>
                    
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        maxWidth: '400px',
                        
                        gap: '20px'
                    }}>
                        {/* Step 1 - Ordered */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                backgroundColor: completedStepColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#666' }}>Organisation Created</span>
                        </div>

                        {/* Step 2 - Sent */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                backgroundColor: isOrgConfigured ? completedStepColor : pendingStepColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#666' }}>Organisation Configured</span>
                        </div>

                        {/* Step 3 - In Delivery */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                backgroundColor: hasCategoryTagsAdded ? completedStepColor : pendingStepColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#666' }}>Contact Groups</span>
                        </div>

                        {/* Step 4 - Delivered */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div style={{
                                width: '30px',
                                height: '30px',
                                borderRadius: '50%',
                                backgroundColor: hasVarificationCodeGenerated ? completedStepColor : pendingStepColor,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0
                            }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#666' }}>Verification Codes</span>
                        </div>
                    </div>
                </div>
            )}
            
            <div className={style.rightbar}>
                <div className={style['page-title']} style={{justifyContent: 'space-between', display: 'flex', alignItems: 'center'}}>
                    <h4 className={`${fontSize.lgSize} ${common.pageTitle} ${font.fontMedium}`}>
                        Settings
                    </h4>
                    <Button variant='light' onClick={() => navigate('/notifications')} >Back to Home</Button>
                </div>

                <div className={style.tabs}>

                    <Tabs 
                        activeKey={key}
                        onSelect={(k) => selectTab(k)}
                        className={style.tabsDesign}
                    >
                        {showRegularAdminView && <Tab eventKey="zero" title="Content Creators" tabClassName={style.colorred}>
                            <Users 
                                orgUuid={orgUuid}
                                setKey={setKey}
                                setSelectedCode={setSelectedCode}
                            />
                        </Tab>}

                        {showRegularAdminView && <Tab eventKey="first" title="Contact Groups" tabClassName={style.colorred}>
                            <CategoryTags 
                                orgUuid={orgUuid} 
                                sCode={selectedCode} 
                                setSelectedCode={setSelectedCode} 
                                setKey={setKey}
                                setHasCategoryTagsAdded={setHasCategoryTagsAdded}
                            />
                        </Tab>}
                        
 {/* Modify Details Tab */}
                    {showRegularAdminView && <Tab eventKey="modify" title="Contact Details">
                        <ModifyDetails orgUuid={orgUuid} />
                    </Tab>
}

                        {showRegularAdminView && <Tab eventKey="Fourth" title="Verification Codes">
                            <SchoolAuthenticationcode 
                                orgUuid={orgUuid} 
                                setKey={setKey} 
                                setSelectedCode={setSelectedCode}
                                setHasVerificationCodeGenerated={setHasVerificationCodeGenerated}
                            />
                        </Tab>}
                        
                        {showRegularAdminView && <Tab eventKey="second" title="App Subscribers">
                            <Parents 
                                orgUuid={orgUuid} 
                                sCode={selectedCode} 
                                setSelectedCode={setSelectedCode} 
                                setKey={setKey}
                            />
                        </Tab>}
                        
                        {/* Only show Organisations tab for non-impersonated internal users */}
                        {(isInternalUser && !isImpersonated) && <Tab eventKey="seventh" title="Organisations">
                            <Organisation setKey={setKey} setSelectedCode={setSelectedCode}/>
                        </Tab>}

                        {/* Only show Internal Users tab for OWNER when not impersonated */}
                        {(isOwner && !isImpersonated) && <Tab eventKey="nineth" title="Internal Users">
                            <InternalUsers orgUuid={orgUuid}/>
                        </Tab>}

                        {/* Only show Plans tab for internal users when not impersonated */}
                        {(isInternalUser && !isImpersonated) && <Tab eventKey="sixth" title="Plans">
                            <Plans orgUuid={orgUuid}/>
                        </Tab>}

                        

                        <Tab eventKey="eighth" title="My Account">
                            <MyAccount orgUuid={orgUuid}/>
                        </Tab>

                        {/* Only show Help tab for internal users when not impersonated */}
                        {(isInternalUser && !isImpersonated) && <Tab eventKey="Fifth" title="Help">
                            <HelpText orgUuid={orgUuid}/>
                        </Tab>}
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

const setupProgressBar = {
    layout: {
    width: '100%',
    height: '4px',
    backgroundColor: '#e0e0e0',
    marginTop: '10px',
    marginBottom: '20px',
    borderRadius: '2px',
    }
};

export default OrgSetting;
